/**
 * src/api/referralApi.ts — caller-scoped referral helpers.
 *
 * GET /MyReferralCode returns the customer's code + share URL + stats.
 * POST /RedeemReferralCode is called once during signup with the ?ref=
 * query param value.
 */

import { getOne, post } from './harperClient';

export interface ReferralStats {
  pending: number;
  completed: number;
  total_credits_earned_cents: number;
}

export interface ReferralInfo {
  code: string;
  share_url: string;
  stats: ReferralStats;
}

export type RedeemResult =
  | { ok: true; reason?: string; referrer_name?: string }
  | { ok: false; reason: string };

export async function getMyReferralCode(): Promise<ReferralInfo | null> {
  return await getOne<ReferralInfo>('/MyReferralCode');
}

export async function redeemReferralCode(code: string): Promise<RedeemResult> {
  return await post<RedeemResult>('/RedeemReferralCode', { code });
}
